// US-region bank list for the BankAccountInlineForm bank-name picker.
// Tenants whose `country = 'US'` see this list in the dropdown; everyone
// else gets a free-text input. New banks the tenant types are unioned in
// from /api/tenant/bank-accounts/recent-banks on subsequent uploads.
export const FAMOUS_US_BANKS: string[] = [
  'Chase',
  'Bank of America',
  'Wells Fargo',
  'Citi',
  'U.S. Bank',
  'PNC',
  'Capital One',
  'TD Bank',
  'Truist',
  'Fifth Third Bank',
  'Regions Bank',
  'Ally Bank',
  'KeyBank',
  'Huntington Bank',
  'M&T Bank',
  'BMO Harris',
  'Citizens Bank',
  'First Citizens Bank',
  'Discover Bank',
  'USAA',
  'Navy Federal Credit Union',
  'Charles Schwab',
  'American Express NB',
  'Goldman Sachs Marcus',
  'SoFi Bank',
  'Synchrony Bank',
  'Comerica',
  'Zions Bank',
  'Northern Trust',
  'Silicon Valley Bank',
]
